import publishDropdownArrowUrl from '@/assets/instruments/publish/publish-dropdown-arrow.svg'
import personaAvatarFemaleUrl from '@/assets/instruments/publish/persona-avatar-female.png'
import personaAvatarMaleUrl from '@/assets/instruments/publish/persona-avatar-male.png'
import personaOtherUrl from '@/assets/instruments/publish/persona-other.png'
import matchComputerUrl from '@/assets/instruments/publish/match-computer.png'
import aiSuggestedStarUrl from '@/assets/instruments/publish/ai-suggested-star.svg'
import matchRefreshUrl from '@/assets/instruments/publish/match-refresh.svg'
import panelChevronUrl from '@/assets/instruments/publish/panel-chevron.svg'
import stepperCircleActiveOuterUrl from '@/assets/instruments/publish/stepper-circle-active-outer.svg'
import stepperCircleActiveInnerUrl from '@/assets/instruments/publish/stepper-circle-active-inner.svg'
import stepperCircleCompletedUrl from '@/assets/instruments/publish/stepper-circle-completed.svg'
import stepperCircleInactiveUrl from '@/assets/instruments/publish/stepper-circle-inactive.svg'
import stepperConnectorActiveUrl from '@/assets/instruments/publish/stepper-connector-active.svg'
import stepperConnectorInactiveUrl from '@/assets/instruments/publish/stepper-connector-inactive.svg'
import channelPushUnselectedUrl from '@/assets/instruments/publish/channel-push-unselected.svg'
import channelPushSelectedUrl from '@/assets/instruments/publish/channel-push-selected.svg'
import channelPushIconUrl from '@/assets/instruments/publish/channel-push-icon.svg'
import channelEmailUnselectedUrl from '@/assets/instruments/publish/channel-email-unselected.svg'
import channelEmailSelectedUrl from '@/assets/instruments/publish/channel-email-selected.svg'
import channelEmailIconUrl from '@/assets/instruments/publish/channel-email-icon.svg'
import channelSmsUnselectedUrl from '@/assets/instruments/publish/channel-sms-unselected.svg'
import channelSmsSelectedUrl from '@/assets/instruments/publish/channel-sms-selected.svg'
import channelSmsIconUrl from '@/assets/instruments/publish/channel-sms-icon.svg'
import channelSelectedBadgeUrl from '@/assets/instruments/publish/channel-selected-badge.svg'
import channelUnselectedBadgeUrl from '@/assets/instruments/publish/channel-unselected-badge.svg'
import instrumentTypeRewardsIconUrl from '@/assets/instruments/publish/instrument-type-rewards-icon.png'
import instrumentTypeNoRewardsIconUrl from '@/assets/instruments/publish/instrument-type-no-rewards-icon.png'
import targetStandardIconUrl from '@/assets/instruments/publish/target-standard.svg'
import targetScientificIconUrl from '@/assets/instruments/publish/target-scientific.svg'
import budgetCheckCircleUrl from '@/assets/instruments/publish/budget-check-circle.svg'
import budgetCheckSmallUrl from '@/assets/instruments/publish/budget-check-small.svg'
import budgetXSmallUrl from '@/assets/instruments/publish/budget-x-small.svg'
import budgetXCircleUrl from '@/assets/instruments/publish/budget-x-circle.svg'
import budgetWarningCircleUrl from '@/assets/instruments/publish/budget-warning-circle.svg'
import budgetWarningSmallUrl from '@/assets/instruments/publish/budget-warning-small.svg'
import futureAudienceConfirmWarningUrl from '@/assets/instruments/publish/future-audience-confirm-warning.svg'
import audienceExistingPeopleUrl from '@/assets/instruments/publish/audience-existing-people.svg'
import audienceFuturePersonUrl from '@/assets/instruments/publish/audience-future-person.svg'
import audienceAllRegisteredPeopleUrl from '@/assets/instruments/publish/audience-all-registered-people.svg'
import audienceFutureInfoUrl from '@/assets/instruments/publish/audience-future-info.svg'
import audienceCardSelectedUrl from '@/assets/instruments/publish/audience-card-selected-fill.svg'
import audienceCardUnselectedCheckUrl from '@/assets/instruments/publish/audience-card-unselected.svg'
import publishSuccessTrophyUrl from '@/assets/instruments/publish/publish-success-trophy.png'

export type PersonaAvatarVariant = 'female' | 'male' | 'other'

export const publishAssets = {
  publishDropdownArrowUrl,
  /** @deprecated Use personaAvatarByVariant — kept for legacy imports */
  personaAvatarUrl: personaAvatarFemaleUrl,
  personaAvatarByVariant: {
    female: personaAvatarFemaleUrl,
    male: personaAvatarMaleUrl,
    other: personaOtherUrl,
  } satisfies Record<PersonaAvatarVariant, string>,
  matchComputerUrl,
  aiSuggestedStarUrl,
  matchRefreshUrl,
  panelChevronUrl,
  stepperCircleActiveOuterUrl,
  stepperCircleActiveInnerUrl,
  stepperCircleCompletedUrl,
  stepperCircleInactiveUrl,
  stepperConnectorActiveUrl,
  stepperConnectorInactiveUrl,
  channelPushUnselectedUrl,
  channelPushSelectedUrl,
  channelPushIconUrl,
  channelEmailUnselectedUrl,
  channelEmailSelectedUrl,
  channelEmailIconUrl,
  channelSmsUnselectedUrl,
  channelSmsSelectedUrl,
  channelSmsIconUrl,
  channelSelectedBadgeUrl,
  channelUnselectedBadgeUrl,
  instrumentTypeRewardsIconUrl,
  instrumentTypeNoRewardsIconUrl,
  targetStandardIconUrl,
  targetScientificIconUrl,
  budgetCheckCircleUrl,
  budgetCheckSmallUrl,
  budgetXSmallUrl,
  /** White ✗ for use on red circular badge (budget-x-small is red stroke for light backgrounds). */
  budgetXCircleUrl,
  /** White ! for use on amber circular badge on Estimated Instrument Cost warning state. */
  budgetWarningCircleUrl,
  /** Amber warning glyph for status rows on light backgrounds. */
  budgetWarningSmallUrl,
  /** Figma `6:940` — warning glyph in cream circle on future-audience confirm. */
  futureAudienceConfirmWarningUrl,
  /** Figma `6:572` — people icon on Existing Responders card. */
  audienceExistingPeopleUrl,
  /** Figma `6:549` — person-check icon on Future Matching card. */
  audienceFuturePersonUrl,
  /** BFP-1141 — white people-group icon on the green All Registered Users card. */
  audienceAllRegisteredPeopleUrl,
  /** Figma `6:668` — info glyph on future-mode banner. */
  audienceFutureInfoUrl,
  /** Figma `6:532` — selected check circle (25×24). */
  audienceCardSelectedUrl,
  /** Figma `6:569` — 10px check inside unselected 20px well. */
  audienceCardUnselectedCheckUrl,
  publishSuccessTrophyUrl,
} as const
